import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentTypeGrid from '../DocumentTypeGrid';

const PickType = ({ documentType, handleSelected, goToNext }) => {
  const { t } = useTranslation();
  const selectedHandler = (val) => {
    if (val) {
      handleSelected(val);
      goToNext();
    }
  };
  return (
    <>
      <h5 className="text-center font-weight-bold">
        {t('contracts.new.document')}
      </h5>
      <DocumentTypeGrid
        selected={documentType}
        handleSelected={selectedHandler}
      />
    </>
  );
};

export default PickType;
